/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import { useLocation } from 'react-router'
import { fetchData, toasterrormsg } from '../../../reusable'
import { Tr } from '../../../_metronic/i18n/Tr';

interface AddCarRentalProps {
  carrentalId: string; // Assuming carrentalId is of type string, adjust as needed
}
const AddCarRentalHeader: React.FC<AddCarRentalProps> = ({ carrentalId }) => {
  const t = Tr()
  const location = useLocation();
  const editCarrentalId = (location.state as any)?.carrentalId || '';

  const [carRentalDetails, setCarRentalDetails] = useState([]);

  // space Details api call
  const carRentalDetailApiCall = async () => {

    if (carrentalId != "") {
      var param: any = {
        carrentalId: String(carrentalId),
      }
    } else if (editCarrentalId != "") {
      var param: any = {
        carrentalId: String(editCarrentalId),
      }
    }
    var response: any = await fetchData("public/carRentalDetail", param)

    if (response.status == "200") {
      setCarRentalDetails(response.data);
    }
    else {
      toasterrormsg(response.message)
    }
  }
  useEffect(() => {

    if (editCarrentalId != "") {
      carRentalDetailApiCall()
    }

  }, [])

  const tabRefs = useRef([]) as any;
  const indexTab = sessionStorage.getItem('indexTab') || 0;

  useEffect(() => {
    const scrollToTab = () => {
      // Check if the tabRefs array is populated and if the indexTab element exists
      if (tabRefs.current.length > 0 && tabRefs.current[indexTab]) {
        // Delay scrollIntoView to ensure all rendering is complete
        setTimeout(() => {
          tabRefs?.current[indexTab]?.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',  // Scroll vertically to nearest edge
            inline: 'center'   // Scroll horizontally to center
          });
        }, 700);
      }
    };
    scrollToTab();
    // Add event listener for window load event to handle case of page refresh
    window.addEventListener('load', scrollToTab);
    // Cleanup function to remove event listener
    return () => {
      window.removeEventListener('load', scrollToTab);
    };
  }, [location, indexTab]);


  return (
    <>
      <div className='card mb-5 mb-xl-10'>
        <div className='card-body'>
          <div className='d-flex overflow-auto'>
            <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder my-2 flex-nowrap'>
              <li className='nav-item'>
                {
                  carRentalDetails && carRentalDetails.length > 0 && carRentalDetails[0]['completedSteps'] && carRentalDetails[0]['completedSteps']['basicInfo'] ? (
                    <Link
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${carRentalDetails && carRentalDetails.length > 0 && carRentalDetails[0]['completedSteps'] && carRentalDetails[0]['completedSteps']['basicInfo'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addcarrentalbasicinfo/' ? `${carRentalDetails && carRentalDetails.length > 0 && carRentalDetails[0]['completedSteps'] && carRentalDetails[0]['completedSteps']['basicInfo'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      to='../addcarrentalbasicinfo/'
                      state={{ carrentalId: editCarrentalId }}
                      ref={el => (tabRefs.current[0] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '0')}
                    >
                      {t('Basic Info')}
                    </Link>
                  ) : (
                    <button
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${carRentalDetails && carRentalDetails.length > 0 && carRentalDetails[0]['completedSteps'] && carRentalDetails[0]['completedSteps']['basicInfo'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addcarrentalbasicinfo/' ? `${carRentalDetails && carRentalDetails.length > 0 && carRentalDetails[0]['completedSteps'] && carRentalDetails[0]['completedSteps']['basicInfo'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      ref={el => (tabRefs.current[0] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '0')}
                    >
                      {t('Basic Info')}
                    </button>
                  )
                }
              </li>
              <li className='nav-item'>
                {
                  carRentalDetails && carRentalDetails.length > 0 && carRentalDetails[0]['completedSteps'] && carRentalDetails[0]['completedSteps']['location'] ? (
                    <Link
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${carRentalDetails && carRentalDetails.length > 0 && carRentalDetails[0]['completedSteps'] && carRentalDetails[0]['completedSteps']['location'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addcarrentallocation/' ? `${carRentalDetails && carRentalDetails.length > 0 && carRentalDetails[0]['completedSteps'] && carRentalDetails[0]['completedSteps']['location'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      to='../addcarrentallocation/'
                      state={{ carrentalId: editCarrentalId }}
                      ref={el => (tabRefs.current[1] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '1')}
                    >
                      {t('Location')}
                    </Link>
                  ) : (
                    <button
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${carRentalDetails && carRentalDetails.length > 0 && carRentalDetails[0]['completedSteps'] && carRentalDetails[0]['completedSteps']['location'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addcarrentallocation/' ? `${carRentalDetails && carRentalDetails.length > 0 && carRentalDetails[0]['completedSteps'] && carRentalDetails[0]['completedSteps']['location'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      ref={el => (tabRefs.current[1] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '1')}
                    >
                      {t('Location')}
                    </button>
                  )
                }
              </li>
              <li className='nav-item' >
                {
                  carRentalDetails && carRentalDetails.length > 0 && carRentalDetails[0]['completedSteps'] && carRentalDetails[0]['completedSteps']['carRentalInfo'] ? (
                    <Link
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${carRentalDetails && carRentalDetails.length > 0 && carRentalDetails[0]['completedSteps'] && carRentalDetails[0]['completedSteps']['carRentalInfo'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/viewcars/' ? `${carRentalDetails && carRentalDetails.length > 0 && carRentalDetails[0]['completedSteps'] && carRentalDetails[0]['completedSteps']['carRentalInfo'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      to='../viewcars/'
                      state={{ carrentalId: editCarrentalId }}
                      ref={el => (tabRefs.current[2] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '2')}
                    >
                      {t('Rental Car Info')}
                    </Link>
                  ) : (
                    <button
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${carRentalDetails && carRentalDetails.length > 0 && carRentalDetails[0]['completedSteps'] && carRentalDetails[0]['completedSteps']['carRentalInfo'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/viewcars/' ? `${carRentalDetails && carRentalDetails.length > 0 && carRentalDetails[0]['completedSteps'] && carRentalDetails[0]['completedSteps']['carRentalInfo'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      ref={el => (tabRefs.current[2] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '2')}
                    >
                      {t('Rental Car Info')}
                    </button>
                  )
                }
              </li>
              <li className='nav-item' >
                {
                  carRentalDetails && carRentalDetails.length > 0 && carRentalDetails[0]['completedSteps'] && carRentalDetails[0]['completedSteps']['photos'] ? (
                    <Link
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${carRentalDetails && carRentalDetails.length > 0 && carRentalDetails[0]['completedSteps'] && carRentalDetails[0]['completedSteps']['photos'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addcarrentalphotos/' ? `${carRentalDetails && carRentalDetails.length > 0 && carRentalDetails[0]['completedSteps'] && carRentalDetails[0]['completedSteps']['photos'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      to='../addcarrentalphotos/'
                      state={{ carrentalId: editCarrentalId }}
                      ref={el => (tabRefs.current[3] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '3')}
                    >
                      {t('Photos')}
                    </Link>
                  ) : (
                    <button
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${carRentalDetails && carRentalDetails.length > 0 && carRentalDetails[0]['completedSteps'] && carRentalDetails[0]['completedSteps']['photos'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addcarrentalphotos/' ? `${carRentalDetails && carRentalDetails.length > 0 && carRentalDetails[0]['completedSteps'] && carRentalDetails[0]['completedSteps']['photos'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      ref={el => (tabRefs.current[3] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '3')}
                    >
                      {t('Photos')}
                    </button>
                  )
                }
              </li>
              <li className='nav-item' >
                {
                  carRentalDetails && carRentalDetails.length > 0 && carRentalDetails[0]['completedSteps'] && carRentalDetails[0]['completedSteps']['insurance'] ? (
                    <Link
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${carRentalDetails && carRentalDetails.length > 0 && carRentalDetails[0]['completedSteps'] && carRentalDetails[0]['completedSteps']['insurance'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addcarrentalinsurance/' ? `${carRentalDetails && carRentalDetails.length > 0 && carRentalDetails[0]['completedSteps'] && carRentalDetails[0]['completedSteps']['insurance'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      to='../addcarrentalinsurance/'
                      state={{ carrentalId: editCarrentalId }}
                      ref={el => (tabRefs.current[4] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '4')}
                    >
                      {t('Insurance')}
                    </Link>
                  ) : (
                    <button
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${carRentalDetails && carRentalDetails.length > 0 && carRentalDetails[0]['completedSteps'] && carRentalDetails[0]['completedSteps']['insurance'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addcarrentalinsurance/' ? `${carRentalDetails && carRentalDetails.length > 0 && carRentalDetails[0]['completedSteps'] && carRentalDetails[0]['completedSteps']['insurance'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      ref={el => (tabRefs.current[4] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '4')}
                    >
                      {t('Insurance')}
                    </button>
                  )
                }
              </li>
              <li className='nav-item' >
                {
                  carRentalDetails && carRentalDetails.length > 0 && carRentalDetails[0]['completedSteps'] && carRentalDetails[0]['completedSteps']['documentsRequired'] ? (
                    <Link
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${carRentalDetails && carRentalDetails.length > 0 && carRentalDetails[0]['completedSteps'] && carRentalDetails[0]['completedSteps']['documentsRequired'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addcarrentaldocuments/' ? `${carRentalDetails && carRentalDetails.length > 0 && carRentalDetails[0]['completedSteps'] && carRentalDetails[0]['completedSteps']['documentsRequired'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      to='../addcarrentaldocuments/'
                      state={{ carrentalId: editCarrentalId }}
                      ref={el => (tabRefs.current[5] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '5')}
                    >
                      {t('Documents Required')}
                    </Link>
                  ) : (
                    <button
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${carRentalDetails && carRentalDetails.length > 0 && carRentalDetails[0]['completedSteps'] && carRentalDetails[0]['completedSteps']['documentsRequired'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addcarrentaldocuments/' ? `${carRentalDetails && carRentalDetails.length > 0 && carRentalDetails[0]['completedSteps'] && carRentalDetails[0]['completedSteps']['documentsRequired'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      ref={el => (tabRefs.current[5] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '5')}
                    >
                      {t('Documents Required')}
                    </button>
                  )
                }
              </li>
              <li className='nav-item' >
                {
                  carRentalDetails && carRentalDetails.length > 0 && carRentalDetails[0]['completedSteps'] && carRentalDetails[0]['completedSteps']['availability'] ? (
                    <Link
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${carRentalDetails && carRentalDetails.length > 0 && carRentalDetails[0]['completedSteps'] && carRentalDetails[0]['completedSteps']['availability'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addcarrentalavailability/' ? `${carRentalDetails && carRentalDetails.length > 0 && carRentalDetails[0]['completedSteps'] && carRentalDetails[0]['completedSteps']['availability'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      to='../addcarrentalavailability/'
                      state={{ carrentalId: editCarrentalId }}
                      ref={el => (tabRefs.current[6] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '6')}
                    >
                      {t('Availability')}
                    </Link>
                  ) : (
                    <button
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${carRentalDetails && carRentalDetails.length > 0 && carRentalDetails[0]['completedSteps'] && carRentalDetails[0]['completedSteps']['availability'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addcarrentalavailability/' ? `${carRentalDetails && carRentalDetails.length > 0 && carRentalDetails[0]['completedSteps'] && carRentalDetails[0]['completedSteps']['availability'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      ref={el => (tabRefs.current[6] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '6')}
                    >
                      {t('Availability')}
                    </button>
                  )
                }
              </li>
              <li className='nav-item' >
                {
                  carRentalDetails && carRentalDetails.length > 0 && carRentalDetails[0]['completedSteps'] && carRentalDetails[0]['completedSteps']['pickupDropoffInfo'] ? (
                    <Link
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${carRentalDetails && carRentalDetails.length > 0 && carRentalDetails[0]['completedSteps'] && carRentalDetails[0]['completedSteps']['pickupDropoffInfo'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addcarrentalpickupordropoffinfo/' ? `${carRentalDetails && carRentalDetails.length > 0 && carRentalDetails[0]['completedSteps'] && carRentalDetails[0]['completedSteps']['pickupDropoffInfo'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      to='../addcarrentalpickupordropoffinfo/'
                      state={{ carrentalId: editCarrentalId }}
                      ref={el => (tabRefs.current[7] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '7')}
                    >
                      {t('Pick-up / Drop-off Info')}
                    </Link>
                  ) : (
                    <button
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${carRentalDetails && carRentalDetails.length > 0 && carRentalDetails[0]['completedSteps'] && carRentalDetails[0]['completedSteps']['pickupDropoffInfo'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addcarrentalpickupordropoffinfo/' ? `${carRentalDetails && carRentalDetails.length > 0 && carRentalDetails[0]['completedSteps'] && carRentalDetails[0]['completedSteps']['pickupDropoffInfo'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      ref={el => (tabRefs.current[7] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '7')}
                    >
                      {t('Pick-up / Drop-off Info')}
                    </button>
                  )
                }
              </li>
              <li className='nav-item' >
                {
                  carRentalDetails && carRentalDetails.length > 0 && carRentalDetails[0]['completedSteps'] && carRentalDetails[0]['completedSteps']['policies'] ? (
                    <Link
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${carRentalDetails && carRentalDetails.length > 0 && carRentalDetails[0]['completedSteps'] && carRentalDetails[0]['completedSteps']['policies'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addcarrentalpolicies/' ? `${carRentalDetails && carRentalDetails.length > 0 && carRentalDetails[0]['completedSteps'] && carRentalDetails[0]['completedSteps']['policies'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      to='../addcarrentalpolicies/'
                      state={{ carrentalId: editCarrentalId }}
                      ref={el => (tabRefs.current[8] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '8')}
                    >
                      {t('Policies')}
                    </Link>
                  ) : (
                    <button
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${carRentalDetails && carRentalDetails.length > 0 && carRentalDetails[0]['completedSteps'] && carRentalDetails[0]['completedSteps']['policies'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addcarrentalpolicies/' ? `${carRentalDetails && carRentalDetails.length > 0 && carRentalDetails[0]['completedSteps'] && carRentalDetails[0]['completedSteps']['policies'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      ref={el => (tabRefs.current[8] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '8')}
                    >
                      {t('Policies')}
                    </button>
                  )
                }
              </li>
              <li className='nav-item' >
                {
                  carRentalDetails && carRentalDetails.length > 0 && carRentalDetails[0]['completedSteps'] && carRentalDetails[0]['completedSteps']['financeAndLegal'] ? (
                    <Link
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${carRentalDetails && carRentalDetails.length > 0 && carRentalDetails[0]['completedSteps'] && carRentalDetails[0]['completedSteps']['financeAndLegal'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addcarrentalfinance/' ? `${carRentalDetails && carRentalDetails.length > 0 && carRentalDetails[0]['completedSteps'] && carRentalDetails[0]['completedSteps']['financeAndLegal'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      to='../addcarrentalfinance/'
                      state={{ carrentalId: editCarrentalId }}
                      ref={el => (tabRefs.current[9] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '9')}
                    >
                      {t('Finance & Legal')}
                    </Link>
                  ) : (
                    <button
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${carRentalDetails && carRentalDetails.length > 0 && carRentalDetails[0]['completedSteps'] && carRentalDetails[0]['completedSteps']['financeAndLegal'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addcarrentalfinance/' ? `${carRentalDetails && carRentalDetails.length > 0 && carRentalDetails[0]['completedSteps'] && carRentalDetails[0]['completedSteps']['financeAndLegal'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      ref={el => (tabRefs.current[9] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '9')}
                    >
                      {t('Finance & Legal')}
                    </button>
                  )
                }
              </li>
              <li className='nav-item'>
                {
                  carRentalDetails && carRentalDetails.length > 0 && carRentalDetails[0]['completedSteps'] && carRentalDetails[0]['completedSteps']['contract'] ? (

                    <Link
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${carRentalDetails && carRentalDetails.length > 0 && carRentalDetails[0]['completedSteps'] && carRentalDetails[0]['completedSteps']['contract'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/viewcarcontract/' ? `${carRentalDetails && carRentalDetails.length > 0 && carRentalDetails[0]['completedSteps'] && carRentalDetails[0]['completedSteps']['contract'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      to='../viewcarcontract/'
                      state={{ carrentalId: editCarrentalId }}
                      ref={el => (tabRefs.current[10] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '10')}
                    >
                      {t('Contract Agreement')}
                    </Link>
                  ) : (
                    <button
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${carRentalDetails && carRentalDetails.length > 0 && carRentalDetails[0]['completedSteps'] && carRentalDetails[0]['completedSteps']['contract'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/viewcarcontract/' ? `${carRentalDetails && carRentalDetails.length > 0 && carRentalDetails[0]['completedSteps'] && carRentalDetails[0]['completedSteps']['contract'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      ref={el => (tabRefs.current[10] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '10')}
                    >
                      {t('Contract Agreement')}
                    </button>
                  )
                }
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  )
}

export { AddCarRentalHeader }
